import { FC } from 'react';
import useEnterReceipts from 'src/hooks/useEnterReceipts';
import useSplitter from 'src/hooks/useSplitter';
import EnterReceiptPreview from 'src/sections/enter_receipt/EnterReceiptPreview';
import AttachDocumentContextProvider from '../attach_document/AttachDocumentContext';
import EnterReceiptNavBar from './EnterReceiptNavBar';

interface ShowScansReceiptProps {
  main: JSX.Element;
}

const ShowScansReceipt: FC<ShowScansReceiptProps> = ({ main }) => {
  const { showPreview, selectedReceiptPoRow, selectedReceiptRow, selectedSupplierReceiptRow } =
    useEnterReceipts();

  const FullPage = useSplitter(main, <EnterReceiptPreview />, showPreview);

  return (
    <AttachDocumentContextProvider
      isInvoice={false}
      poId={selectedReceiptPoRow?.poId}
      receiptId={selectedReceiptRow?.receivingReceiptId}
      supplierId={selectedSupplierReceiptRow.offlineSupplierId}
      isEnterReceipts
      isNewTab={false}
    >
      <EnterReceiptNavBar />
      {FullPage}
    </AttachDocumentContextProvider>
  );
};

export default ShowScansReceipt;
